// @ts-nocheck
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useReportingMap } from 'sonata-platform-components';
import { VerticalTabs } from 'sonata-react-components';

import { MapRankingPanel } from '@/ts-modules/reporting/Map/MapRankingPanel';
import { RankingRightPanelStyled } from '@/ts-modules/reporting/Map/RankingRightPanel/rankingRightPanel.style';

type Props = {
  className?: string;
  isFootfallAttrMap?: boolean;
  mapId: string;
};

export function RankingRightPanel({ className, isFootfallAttrMap, mapId }: Props) {
  const { formatMessage } = useIntl();

  const { getMap } = useReportingMap();
  const map = getMap({ id: mapId });

  const mapType = ['single', 'heatmap', 'cartography'].includes(map!.type) ? 'cartography' : map!.type;

  const tabsConfig = useMemo(
    () => [
      {
        Component: MapRankingPanel,
        componentConfig: {
          filterSection: 'maps',
          isFootfallAttrMap,
          mapId
        },
        description: formatMessage({
          defaultMessage: `Ranking by ${mapType}`,
          id: `reporting.map.rankingRightPanel.title.${mapType}`
        }),
        icon: 'fas fa-chart-bar',
        id: 'rankingByCartography',
        name: formatMessage({
          defaultMessage: `Ranking by ${mapType}`,
          id: `reporting.map.rankingRightPanel.title.${mapType}`
        }),
        theme: 'light',
        visible: true
      }
    ],
    [mapType]
  );

  return (
    <RankingRightPanelStyled className={`rankingRightPanel ${className}`}>
      <VerticalTabs
        customClass="mapRankingRightPanel"
        defaultActive="rankingByCartography"
        fixWidth={313}
        sidebarPosition="right"
        tabsConfig={tabsConfig}
      />
    </RankingRightPanelStyled>
  );
}
